import React from 'react';

const DeleteIcon = ({ width = 20, height = 20, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3248 2.74167L12.9165 3.33333H14.9998C15.4582 3.33333 15.8332 3.70833 15.8332 4.16667C15.8332 4.625 15.4582 5 14.9998 5H4.99984C4.5415 5 4.1665 4.625 4.1665 4.16667C4.1665 3.70833 4.5415 3.33333 4.99984 3.33333H7.08317L7.67484 2.74167C7.82484 2.59167 8.0415 2.5 8.25817 2.5H11.7415C11.9582 2.5 12.1748 2.59167 12.3248 2.74167ZM4.99984 15.8333C4.99984 16.75 5.74984 17.5 6.6665 17.5H13.3332C14.2498 17.5 14.9998 16.75 14.9998 15.8333V7.5C14.9998 6.58333 14.2498 5.83333 13.3332 5.83333H6.6665C5.74984 5.83333 4.99984 6.58333 4.99984 7.5V15.8333ZM7.49984 7.5H12.4998C12.9582 7.5 13.3332 7.875 13.3332 8.33333V15C13.3332 15.4583 12.9582 15.8333 12.4998 15.8333H7.49984C7.0415 15.8333 6.6665 15.4583 6.6665 15V8.33333C6.6665 7.875 7.0415 7.5 7.49984 7.5Z"
      fill={color}
    />
  </svg>
);

export default DeleteIcon;
